import { Routes } from '@angular/router';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { AuthGuard } from './shared/guards/auth-guards';
import { LoginComponent } from './navigation/login/login.component';
import { LoginGuard } from './shared/guards/login-guard';
import { HomeComponent } from './layout/home/home.component';
import { RequisitionsGuard } from './shared/guards/requisitions-guard';
import { EstimationsGuard } from './shared/guards/estimations-guard';
import {ProjectManagementModule} from "./features/project-management/project-management.module";

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [LoginGuard],
    component: LoginComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: HomeComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'requisiciones',
        canActivate: [RequisitionsGuard],
        loadChildren: () =>
          import('./features/requisitions/requisitions.module').then(
            (m) => m.RequisitionsModule
          ),
        },
        {
        path: 'estimaciones',
        canActivate: [EstimationsGuard],
        loadChildren: () =>
          import('./features/estimations/estimations.module').then(
            (m) => m.EstimationsModule
          ),
      },
      {
        path: 'project-management',
        loadChildren: () =>
          import('./features/project-management/project-management.module').then(
            (m) => m.ProjectManagementModule
          ),
      }
    ]
  },
];
